<template>
  <router-link :to="articleRoute">
    <div :class="['alert', 'article-preview', `alert-${articleType}`]" role="alert">
        <h4 class="alert-heading">
          {{ article.translations[$i18n.locale].title }}
          <font-awesome-icon icon="link" />
        </h4>
        <template v-if="article.translations[$i18n.locale].description">
          <hr>
          <i><small class="">{{article.translations[$i18n.locale].description}}</small></i>
        </template>
    </div>
  </router-link>
</template>
<script>
import article from '@/mixins/articles'

export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  mixins: [article],
  computed: {
    articleType(){
      return this.articleTypes.includes(this.article.type) ? this.article.type : 'info'
    },
    articleRoute(){
      return {
        name: 'client-article',
        params: {
          id: this.article.id
        }
      }
    }
  }
}
</script>